import React, {Fragment, useLayoutEffect, useState} from "react";
import {Menu, Transition} from "@headlessui/react";
import classNames from "classnames";
import {Domain} from "@commons/mapping/LoginResultRecord";
import {useAppDispatch, useAppSelector} from "@hooks/redux-hooks/hooks";
import {selectDomini, selectToken, selectUser} from "@commons/core.slice";
import {changeDomain, changePeriodo} from "@commons/actions/environment.action";
import IntegerInput from "../components/IntegerInput";
import moment from "moment";
import {toast} from "react-toastify";
import {TokenRecord} from "@commons/mapping/TokenRecord";
import {UserCRUDRecord} from "@commons/mapping/UserCRUDRecord";
import {historyApp} from "@helpers/history";
import {logout} from "@commons/actions/authentication.action";
import {alignMenu} from "@coreMenu/slice";
import {IconDoorExit, IconUserCog} from "@tabler/icons-react";

const UserMenu: React.FC<any> = () => {
    const token: TokenRecord | null = useAppSelector(selectToken);
    const user: UserCRUDRecord | null = useAppSelector(selectUser);
    const dispatch = useAppDispatch();


    const _logout = () => {
        dispatch(logout(token?.token!));
        // Forzo pagina di welcome dopo logout
        if (historyApp.navigate) {
            const newStato = `/welcome`;
            historyApp.navigate(newStato);
            dispatch(alignMenu({newStato, oldStato: historyApp.location.pathname}));
        }
    }

    const userMenuItems = [
        {
            name: 'Il mio profilo', href: '#', handleClick: () => {
            }, icon: <IconUserCog size={19}/>
        },
        {
            name: 'Info', href: '#', handleClick: () => {
            }
        },
        {
            name: `Logout`, href: '#', handleClick: _logout,
            icon: <IconDoorExit size={19}/>
        },
    ]


    const domini: Domain[] = useAppSelector(selectDomini);
    const currentAnno = token ? token.anno : moment().year();
    const currentMese = token ? token.mese : moment().month();
    const [anno, setAnno] = useState<number>(currentAnno);
    const [mese, setMese] = useState<number>(currentMese);
    const [menuOpen, setMenuOpen] = useState<boolean>(false); // stato del menu, true aperto!
    //console.log('menuOpen', menuOpen)

    function isPeriodoChanged() {
        return anno !== currentAnno || mese !== currentMese;
    }

    function getCurrentDomain() {
        const current = domini.filter((dominio) => (dominio.current));
        return current.length > 0 ? current[0].idDomain : (token ? token.idDominio : undefined);
    }

    const [domain, setDomain] = useState<number | undefined>(getCurrentDomain());

    function cambioDominio() {
        if (domain)
            dispatch(changeDomain(domain)).then((r) => {
                //console.log('changeDomain', changeDomain.fulfilled.name, changeDomain.fulfilled.type);
                //console.log('rejected', changeDomain.rejected.name, changeDomain.rejected.type);
                if (r.type === changeDomain.fulfilled.type)
                    toast("Il dominio corrente è stato aggiornato.", {type: 'success'})
                else if (r.type === changeDomain.rejected.type)
                    toast("ERRORE nel modificare il dominio!", {type: 'error'})
            });
    }

    function cambioPeriodo() {
        if (token)
            dispatch(changePeriodo({token: token.token, anno, mese})).then((r) => {
                if (r.type === changePeriodo.fulfilled.type)
                    toast("Il periodo corrente è stato aggiornato.", {type: 'success'})
                else if (r.type === changePeriodo.rejected.type)
                    toast("ERRORE nel modificare il periodo!", {type: 'error'})
            });
    }

    useLayoutEffect(() => { // Controllo variazione stato menu: se cambia da chiuso ad aperto resetto valori correnti!
        //if (menuOpen) {
        setAnno(currentAnno);
        setMese(currentMese);
        setDomain(getCurrentDomain());
        //}
    }, [menuOpen]);

    const sesso = UserCRUDRecord.getSesso(user);
    return (
        <>
            <Menu as="div" className="relative ml-3">
                {({open}) => {
                    //if (open && !menuOpen)
                    //setMenuOpen(open); // generare errore!!!
                    return (
                        <>
                            <div>
                                <Menu.Button
                                    className="flex max-w-xs items-center rounded-full bg-white text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                                    onClick={() => setMenuOpen(!menuOpen)}
                                >
                                    <span>{user!.userName}</span>
                                    <img
                                        className="h-8 w-8 rounded-full"
                                        /*src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"*/
                                        src={`${process.env.PUBLIC_URL}/images/avatar_${sesso}.jpg`}
                                        alt=""
                                    />
                                </Menu.Button>
                            </div>
                            <Transition
                                as={Fragment}
                                enter="transition ease-out duration-100"
                                enterFrom="transform opacity-0 scale-95"
                                enterTo="transform opacity-100 scale-100"
                                leave="transition ease-in duration-75"
                                leaveFrom="transform opacity-100 scale-100"
                                leaveTo="transform opacity-0 scale-95"
                            >
                                <Menu.Items
                                    className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none divide-y divide-gray-100">

                                    {/*CAMBIO DOMINIO*/}
                                    <div>
                                        <div className="my-2 mx-2 text-sm">
                                            <label className="block text-sm">Dominio</label>
                                            <select
                                                id="selDominio"
                                                name="selDominio"
                                                className="block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-blue-500 focus:outline-none focus:ring-blue-500 sm:text-sm"
                                                value={domain}
                                                onChange={(e) => setDomain(parseInt(e.target.value))}
                                            >
                                                {domini.map((item, index) => (
                                                    <option key={index} value={item.idDomain}>{item.descrizione}</option>))}
                                            </select>
                                            <button className="mt-2 btnPrimary"
                                                    disabled={domain === getCurrentDomain()}
                                                    onClick={() => cambioDominio()}>Cambia dominio
                                            </button>
                                        </div>
                                    </div>

                                    {/*CAMBIO PERIODO*/}
                                    <div>
                                        <div className="my-2 mx-2">
                                            <IntegerInput className="text-sm" name="anno" label="Anno" value={anno} setValue={setAnno} valueMin={1900}/>
                                            <IntegerInput className="text-sm" name="mese" label="Mese" value={mese} setValue={setMese} valueMin={1} valueMax={12}/>
                                            <button className="mt-2 btnPrimary"
                                                    disabled={!isPeriodoChanged()}
                                                    onClick={() => cambioPeriodo()}>Cambia periodo
                                            </button>
                                            {/*                        <hr className="mt-2"/>*/}
                                        </div>
                                    </div>
                                    <div>
                                        {userMenuItems.map((item) => (
                                            <Menu.Item key={item.name}>
                                                {({active}) => (
                                                    <a href={item.href}
                                                       className={classNames(active ? 'bg-gray-100' : '', 'block px-4 py-2 text-sm', item.icon ? 'inline-flex w-full' : '')}
                                                       onClick={item.handleClick}
                                                    >
                                                        {item.name}{item.icon && <>&nbsp;{item.icon}</>}
                                                    </a>
                                                )}
                                            </Menu.Item>
                                        ))}
                                    </div>
                                </Menu.Items>
                            </Transition>

                        </>
                    )
                }}
            </Menu>
            {/*
            <Notification title="Il dominio corrente è stato aggiornato!"></Notification>
            <Notification title="Il periodo corrente è stato aggiornato!"></Notification>
*/}
        </>
    )
}
export default UserMenu;
